import React, { useEffect, useState } from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";

interface _IFrameProps {
  id: string;
  src: string;
  styles: any;
  title: string;
  type: string;
}

export default function Iframe(propsData: any) {
  try {
    const [src, setSrc] = useState("");
    const { id, styles, title } = propsData || {};
    const [isLoading, setLoading] = useState(true);
    useEffect(() => {
      const iframeQuery = window.location.search;
      let { src } = propsData;
      let query = "";
      if (iframeQuery !== "" && iframeQuery.includes("iframeQuery")) {
        if (propsData.src.includes("?")) {
          query = iframeQuery.replace("?iframeQuery=?", "&");
        } else {
          query = iframeQuery.replace("?iframeQuery=", "");
        }
        src += query;
      }
      setSrc(src)
      setLoading(false);
    }, []);

    if (isLoading) {
      return <p>Loading...</p>
    }
    return (
      src && (
          <DtvBox
            sx={{
              padding: "0rem 10% 5rem 10%",
              ...styles
            }}
          >
            <DtvBox
              component="iframe"
              id={id}
              src={src}
              title={title}
              sx={{
                display: "inline-flex",
                flexGrow: 1,
                margin: 0,
                width: "100%",
                height: "900px",
                ...styles
              }}
            ></DtvBox>
          </DtvBox>
      )
    );
  } catch (error) {
    console.log("iframe-error", error);
    return <ErrorDisplay error={error} />;
  }
}
